import { createRoute } from '@tanstack/react-router';
import { labExpiredParentRoute } from 'pages/lab/labParentRoute';
import { zodPathParamId } from 'routes/routeUtils';
import { z } from 'zod';

export const labExpiredProductsRequestRoute = createRoute({
  getParentRoute: () => labExpiredParentRoute,
  path: '/$id',
  params: z.object({ id: zodPathParamId }),
}).lazy(() =>
  import(
    'pages/lab/ExpiredProductsRequests/LabExpiredProductsRequestPage/LabExpiredProductsRequestPage'
  ).then((d) => d.Route)
);
